$("#coupon-form").on("submit", function (e) {
    e.preventDefault();
    $.post('/it/shop/coupon', {
        coupon_code: $('[name="coupon_code"]').val()
    }, function (response) {
        location.reload();
    }).fail(function (error) {
        $('#coupon-status p').text(error.responseJSON.errors)
        $('#coupon-status').show();
    })
})
$(".delete-row").on("click", function (e) {

    var $el = $(this);
    var data = ($el.data('item_id') !== undefined)
        ? {item_id: $el.data('item_id'), ticket_dealer_id: $el.data('ticket_dealer_id') || ''}
        : {row_num: $el.data('row_num')};

    $.post('/it/shop/removeCartRow', data, function (response) {
        window.location.href = "/it/shop/cart.html";
    })
})